module.exports = __webpack_public_path__ + "images/social/home-28d53bc1.jpg";